import { Box, TextField } from "@mui/material";
import { format } from "date-fns";

type Props = {
  start: number;
  end: number;
};

export function ReadOnlyDates({ start, end }: Props) {
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          direction: "row",
        }}
      >
        <TextField
          value={start ? format(new Date(start), "do 'of' MMMM',' yyyy") : "-"}
          variant="standard"
          id="solution-start-date"
          label="Start Date"
          size="small"
          sx={{
            paddingRight: 2,
          }}
          InputProps={{
            readOnly: true,
            disableUnderline: true,
          }}
        />
        <TextField
          value={end ? format(new Date(end), "do 'of' MMMM',' yyyy") : "-"}
          variant="standard"
          id="solution-end-date"
          label="End Date"
          size="small"
          InputProps={{
            readOnly: true,
            disableUnderline: true,
          }}
        />
      </Box>
    </Box>
  );
}
